import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll to top on every route change so pages never load mid-screen.
 * Uses "instant" on true navigations so the previous scroll position doesn't flash.
 */
export default function ScrollToTop() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        // Skip for same-path anchor changes (e.g., query-only updates on shop filters can opt-in later)
        try {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        } catch (_) {
            window.scrollTo(0, 0);
        }
    }, [pathname, search]);

    return null;
}
